(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDrawer {
    constructor(root) {
      this.root = root;
      this.panel = root.querySelector('[data-cart-panel]');
      this.lines = root.querySelector('[data-cart-lines]');
      this.empty = root.querySelector('[data-cart-empty]');
      this.foot = root.querySelector('[data-cart-foot]');
      this.subtotal = root.querySelector('[data-cart-subtotal]');
      this.countLabel = root.querySelector('[data-cart-count-label]');
      this.flash = root.querySelector('[data-cart-flash]');
      this.routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.cart = null;

      root.querySelectorAll('[data-cart-close]').forEach((node) => {
        node.addEventListener('click', () => this.close());
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !root.hidden) this.close();
      });

      this.lines.addEventListener('click', (event) => this.onLineClick(event));

      // The header's cart icon opens the panel instead of leaving the page;
      // the link underneath still works without scripting.
      document.querySelectorAll('a.header__cart').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        });
      });

      document.addEventListener('cart:updated', (event) => this.paintBadge(event.detail.cart));
    }

    /* Public door ---------------------------------------------------------- */

    async open() {
      this.root.hidden = false;
      document.body.classList.add('cart-drawer-open');
      this.lastFocus = document.activeElement;
      if (this.panel) this.panel.focus();
      document.dispatchEvent(new CustomEvent('cart:open'));
      await this.refresh();
    }

    close() {
      this.root.hidden = true;
      document.body.classList.remove('cart-drawer-open');
      if (this.flash) this.flash.hidden = true;
      document.dispatchEvent(new CustomEvent('cart:close'));
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }

    async refresh() {
      this.root.classList.add('is-busy');
      try {
        const response = await fetch(this.routeRoot + 'cart.js', { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        this.render(cart);
        return cart;
      } finally {
        this.root.classList.remove('is-busy');
      }
    }

    // A product form has just posted: show the panel with the new lines and a
    // one-line confirmation at the top.
    async added() {
      await this.open();
      if (this.flash) {
        this.flash.hidden = false;
        window.clearTimeout(this.flashTimer);
        this.flashTimer = window.setTimeout(() => {
          if (this.flash) this.flash.hidden = true;
        }, 4000);
      }
      if (this.panel) this.panel.scrollTop = 0;
    }

    /* Changes -------------------------------------------------------------- */

    async change(key, quantity) {
      this.root.classList.add('is-busy');
      try {
        const response = await fetch(this.routeRoot + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity }),
        });
        const cart = await response.json();
        if (response.ok) this.render(cart);
      } finally {
        this.root.classList.remove('is-busy');
      }
    }

    onLineClick(event) {
      const button = event.target.closest('[data-cart-qty], [data-cart-remove]');
      if (!button) return;
      const line = button.closest('[data-cart-line]');
      if (!line) return;
      const key = line.dataset.cartLine;
      const current = Number(line.dataset.cartQuantity) || 1;

      if (button.hasAttribute('data-cart-remove')) {
        this.change(key, 0);
        return;
      }

      const step = Number(button.dataset.cartQty);
      this.change(key, Math.max(current + step, 0));
    }

    /* Drawing -------------------------------------------------------------- */

    render(cart) {
      this.cart = cart;
      const items = this.grouped(cart.items || []);

      this.lines.innerHTML = items.map((item) => this.lineHtml(item)).join('');
      this.empty.hidden = items.length > 0;
      this.foot.hidden = items.length === 0;
      if (this.subtotal) this.subtotal.innerHTML = this.money(cart.items_subtotal_price || cart.total_price || 0);
      if (this.countLabel) {
        this.countLabel.textContent = items.length
          ? this.root.dataset.stringCount.replace('__count__', cart.item_count)
          : '';
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }

    // The cart lists newest first, which puts an add-on above the piece it was
    // bought for. Each add-on is moved to sit under its product instead; the
    // `_group` property the forms write is what pairs them.
    grouped(items) {
      const isExtra = (item) => item.properties && Object.prototype.hasOwnProperty.call(item.properties, 'Added to');
      const groupOf = (item) => item.properties && item.properties._group;
      const parents = items.filter((item) => !isExtra(item));
      const extras = items.filter(isExtra);
      const out = [];
      parents.forEach((parent) => {
        out.push(parent);
        extras.forEach((extra) => {
          if (groupOf(extra) && groupOf(extra) === groupOf(parent) && out.indexOf(extra) === -1) out.push(extra);
        });
      });
      extras.forEach((extra) => {
        if (out.indexOf(extra) === -1) out.push(extra);
      });
      return out;
    }

    lineHtml(item) {
      const props = item.properties || {};
      const extra = Object.prototype.hasOwnProperty.call(props, 'Added to');
      const meta = [];

      // The variant title is the option values joined; a single-variant
      // product reports "Default Title", which says nothing to anyone.
      if (item.variant_title && item.variant_title !== 'Default Title') meta.push(this.text(item.variant_title));

      // Underscored properties are the shop's own notes (the photo files, the
      // grouping id) and stay out of the customer's view here as at checkout.
      Object.keys(props).forEach((key) => {
        if (key.charAt(0) === '_' || !props[key]) return;
        if (key === 'Added to') {
          meta.push(this.root.dataset.stringAddedTo.replace('__title__', this.text(props[key])));
          return;
        }
        meta.push('<b>' + this.text(key) + ':</b> ' + this.text(String(props[key]).slice(0, 80)));
      });

      const image = item.featured_image && item.featured_image.url ? this.thumb(item.featured_image.url) : '';

      return (
        '<li class="cart-drawer__line' + (extra ? ' cart-drawer__line--extra' : '') + '" data-cart-line="' + this.text(item.key) + '" data-cart-quantity="' + item.quantity + '">' +
          (image
            ? '<img class="cart-drawer__thumb" src="' + image + '" alt="" width="72" height="72" loading="lazy">'
            : '<span class="cart-drawer__thumb"></span>') +
          '<div>' +
            '<p class="cart-drawer__line-title"><a href="' + this.text(item.url) + '">' + this.text(item.product_title) + '</a></p>' +
            (meta.length ? '<p class="cart-drawer__line-meta">' + meta.map((line) => '<span>' + line + '</span>').join('') + '</p>' : '') +
            '<div class="cart-drawer__line-row">' +
              '<span class="cart-drawer__qty" aria-label="' + this.text(this.root.dataset.stringQuantity) + '">' +
                '<button type="button" data-cart-qty="-1" aria-label="−">' + this.icon('M5 12h14') + '</button>' +
                '<output>' + item.quantity + '</output>' +
                '<button type="button" data-cart-qty="1" aria-label="+">' + this.icon('M12 5v14M5 12h14') + '</button>' +
              '</span>' +
              '<span class="cart-drawer__line-price">' + this.money(item.final_line_price) + '</span>' +
            '</div>' +
            '<button class="cart-drawer__remove" type="button" data-cart-remove>' + this.text(this.root.dataset.stringRemove) + '</button>' +
          '</div>' +
        '</li>'
      );
    }

    icon(path) {
      return '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="' + path + '"/></svg>';
    }

    thumb(url) {
      try {
        const parsed = new URL(url, window.location.origin);
        parsed.searchParams.set('width', '160');
        return parsed.toString();
      } catch (error) {
        return url;
      }
    }

    paintBadge(cart) {
      document.querySelectorAll('a.header__cart').forEach((link) => {
        let badge = link.querySelector('.header__cart-count');
        if (cart.item_count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'header__cart-count';
            badge.setAttribute('aria-hidden', 'true');
            link.appendChild(badge);
          }
          badge.textContent = cart.item_count;
        } else if (badge) {
          badge.remove();
        }
      });
    }

    text(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    money(cents) {
      const format = this.root.dataset.moneyFormat;
      const open = '\\{' + '\\{';
      const close = '\\}' + '\\}';
      const placeholder = new RegExp(open + '\\s*(\\w+)\\s*' + close);
      const match = format ? format.match(placeholder) : null;
      if (!match) return (cents / 100).toFixed(2);
      let precision = 2;
      let thousands = ',';
      let decimal = '.';
      const kind = match[1];
      if (kind.indexOf('no_decimals') !== -1) precision = 0;
      if (kind.indexOf('comma_separator') !== -1) {
        thousands = '.';
        decimal = ',';
      } else if (kind.indexOf('apostrophe_separator') !== -1) {
        thousands = "'";
      } else if (kind.indexOf('period_and_space_separator') !== -1) {
        thousands = ' ';
      } else if (kind.indexOf('space_separator') !== -1) {
        thousands = ' ';
        decimal = ',';
      }
      const parts = (cents / 100).toFixed(precision).split('.');
      const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return format.replace(placeholder, () => (parts[1] ? whole + decimal + parts[1] : whole));
    }
  }

  const drawerRoot = document.querySelector('[data-cart-drawer]');
  if (drawerRoot) window.MimoraCart = new CartDrawer(drawerRoot);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["personalizer"] && !Shopify.designMode) return;
  try {
    /* The personalizer collects personalization: the photos, the lines that get
     printed, the notes, and the add-ons. It does not choose the variant.

     Which size or how many pieces is a variant decision — it moves the price,
     the SKU, the stock and the URL — so it stays with the product form and its
     swatches, where the browser's own history and Shopify's own variant data
     already handle it. This class only listens for that choice, because how
     many photos to ask for follows from it. */
  class Personalizer {
    constructor(root) {
      this.root = root;
      this.form = root.closest('form');

      const configNode = root.querySelector('[data-charm-config]');
      if (!this.form || !configNode) return;

      try {
        this.config = JSON.parse(configNode.textContent);
      } catch (error) {
        // The bundle is wrapped in a closure that swallows throws, so a bad
        // config would otherwise fail invisibly and leave the plain inputs.
        console.error('[personalizer] could not read its settings:', error);
        return;
      }

      this.strings = this.config.strings || {};
      this.photos = [];
      this.units = this.config.units || 1;
      this.variantPrice = this.config.variantPrice || 0;

      this.slots = Array.from(root.querySelectorAll('[data-charm-slot]'));
      this.fileInputs = Array.from(root.querySelectorAll('[data-charm-file]'));
      this.extraInputs = Array.from(root.querySelectorAll('[data-charm-extra]'));
      this.fieldInputs = Array.from(root.querySelectorAll('[data-charm-field]'));
      this.subjectInputs = Array.from(root.querySelectorAll('[data-charm-subject]'));
      this.choiceInputs = Array.from(root.querySelectorAll('[data-charm-choice]'));
      this.unitBlocks = Array.from(root.querySelectorAll('[data-charm-unit]'));
      this.colourBlock = root.querySelector('[data-charm-colours]');
      this.colourSkipNote = root.querySelector('[data-charm-colours-skip]');
      this.quoteCustom = root.querySelector('[data-charm-quote-custom]');
      this.quoteExtra = root.querySelector('[data-charm-quote-extra]');
      this.notesInput = root.querySelector('[name="properties[Notes]"]');

      this.picker = root.querySelector('[data-charm-picker]');
      this.frames = root.querySelector('[data-charm-frames]');
      this.photoCount = root.querySelector('[data-charm-photo-count]');
      this.errorNode = root.querySelector('[data-charm-error]');
      this.totalNode = root.querySelector('[data-charm-total]');
      this.submitButton = root.querySelector('[data-charm-submit]');
      this.submitText = root.querySelector('[data-charm-submit-text]');
      this.idInput = this.form.querySelector('[data-variant-id]');

      // Every panel is visible without scripting, so the browser can point at
      // an empty required field itself. Once this class is running the errors
      // are its own, and a native message would arrive on top of them.
      this.form.noValidate = true;
      root.classList.add('charm--js');

      try {
        this.bind();
        this.applySubject(this.subjectIndex());
        this.syncSlots();
        this.updateTotal();
      } catch (error) {
        console.error('[personalizer] failed to start:', error);
        root.classList.remove('charm--js');
      }
    }

    bind() {
      this.extraInputs.forEach((input) => {
        input.addEventListener('change', () => this.updateTotal());
      });

      this.subjectInputs.forEach((input) => {
        input.addEventListener('change', () => this.applySubject(Number(input.dataset.charmSubject)));
      });

      this.fieldInputs.forEach((input) => {
        input.addEventListener('input', () => {
          if (input.getAttribute('aria-invalid') === 'true') {
            input.removeAttribute('aria-invalid');
            this.showError('');
          }
        });
      });

      if (this.frames && this.picker) {
        this.picker.addEventListener('change', () => {
          this.addFiles(Array.from(this.picker.files || []));
          this.picker.value = '';
        });

        // A photograph can be dropped anywhere on the row, not only on the one
        // empty frame the shopper happened to aim at.
        ['dragenter', 'dragover'].forEach((name) => {
          this.frames.addEventListener(name, (event) => {
            event.preventDefault();
            this.frames.classList.add('is-dragging');
          });
        });

        ['dragleave', 'drop'].forEach((name) => {
          this.frames.addEventListener(name, () => this.frames.classList.remove('is-dragging'));
        });

        this.frames.addEventListener('drop', (event) => {
          event.preventDefault();
          const dropped = event.dataTransfer ? Array.from(event.dataTransfer.files || []) : [];
          this.addFiles(dropped);
        });
      }

      this.root.querySelectorAll('[data-charm-reveal]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const name = trigger.dataset.charmReveal;
          const target = this.root.querySelector('[data-charm-reveal-target="' + name + '"]');
          if (!target) return;
          const open = target.hidden;
          target.hidden = !open;
          trigger.setAttribute('aria-expanded', String(open));
        });
      });

      // The product form owns the variant and announces every change.
      const host = this.root.closest('[data-product-root]') || document;
      host.addEventListener('product:variant', (event) => this.onVariant(event.detail));

      this.choiceInputs.forEach((input) => {
        input.addEventListener('change', () => this.onChoice(input));
      });
      this.applyColourSkip(this.config.variantTitle);
      this.syncQuote();

      this.form.addEventListener('submit', (event) => this.onSubmit(event));
    }

    /* Who it is being made for -------------------------------------------- */

    subjectIndex() {
      const checked = this.subjectInputs.find((input) => input.checked);
      return checked ? Number(checked.dataset.charmSubject) : 0;
    }

    // Choosing a person over a pet changes no price and no variant, only the
    // advice: what to photograph, what to mention, what each slot is called.
    applySubject(index) {
      const subject = (this.config.subjects || [])[index];
      if (!subject) return;

      this.toggleBySubject('[data-charm-subject-note]', 'charmSubjectNote', index);
      this.toggleBySubject('[data-charm-subject-guide]', 'charmSubjectGuide', index);

      if (this.notesInput && subject.notesPlaceholder) {
        this.notesInput.placeholder = subject.notesPlaceholder;
      }

      this.relabelSlots(subject.unitLabel);
    }

    toggleBySubject(selector, key, index) {
      this.root.querySelectorAll(selector).forEach((node) => {
        node.hidden = Number(node.dataset[key]) !== index;
      });
    }

    relabelSlots(unit) {
      const template = this.config.photoSlotUnit;
      if (!template || !unit) return;

      this.root.querySelectorAll('[data-charm-slot-label]').forEach((node) => {
        const number = node.dataset.charmSlotLabel;
        node.textContent = template.replace('__u__', unit).replace('__n__', number);
      });
    }

    /* The variant, as reported by the product form ------------------------ */

    onVariant(detail) {
      const variant = detail && detail.variant;
      if (!variant) {
        this.setAvailable(false);
        return;
      }

      this.variantPrice = variant.price;
      this.applyColourSkip(variant.title);
      this.units = this.unitsFor(variant);
      this.setAvailable(variant.available);
      this.syncSlots();
      this.updateTotal();
    }

    // "2 Pets" means two pieces and two photographs. "8 INCHES" means one
    // piece that happens to be large, so a counted style is the only place a
    // number in the option value is read as a quantity.
    unitsFor(variant) {
      if (!this.config.countTiers) return 1;

      const index = this.config.tierOptionIndex;
      const value = index >= 0 && variant.options ? variant.options[index] : null;
      const count = parseInt(value, 10);
      return count > 0 ? count : 1;
    }

    setAvailable(available) {
      if (!this.submitButton) return;
      this.submitButton.disabled = !available;
      if (this.submitText) {
        this.submitText.textContent = available ? this.strings.addToCart : this.strings.soldOut;
      }
    }

    updateTotal() {
      if (!this.totalNode) return;
      let total = this.variantPrice;
      this.extraInputs.forEach((input) => {
        if (input.checked) total += Number(input.dataset.charmExtraPrice || 0);
      });
      // innerHTML, not textContent: the money format may include markup.
      const html = this.money(total);
      this.totalNode.innerHTML = html;

      // The sticky bar repeats this figure wherever the shopper has scrolled to.
      const extras = this.extraInputs.filter((input) => input.checked).length;
      this.root.dispatchEvent(
        new CustomEvent('product:total', {
          bubbles: true,
          detail: { total: total, html: html, extras: extras },
        })
      );
    }

    /* Choices: colours and quotes ------------------------------------------ */

    onChoice(input) {
      if (input.hasAttribute('data-charm-quote-option')) this.syncQuote();
      this.showError('');
    }

    // "My own quote" opens the box to write it in and puts the custom-quote
    // line in the basket; a preset takes both away again.
    syncQuote() {
      const custom = this.choiceInputs.find((input) => input.hasAttribute('data-charm-quote-is-custom'));
      const on = !!(custom && custom.checked);
      if (this.quoteCustom) this.quoteCustom.hidden = !on;
      if (this.quoteExtra) {
        this.quoteExtra.checked = on;
        this.updateTotal();
      }
    }

    // A charm-only set has no bag to colour: the colour step stands aside and
    // says why.
    applyColourSkip(title) {
      if (!this.colourBlock) return;
      const match = String(this.config.colourSkipMatch || '').trim().toLowerCase();
      const skip = !!(match && title && String(title).toLowerCase().indexOf(match) !== -1);
      this.colourBlock.hidden = skip;
      if (this.colourSkipNote) this.colourSkipNote.hidden = !skip;
    }

    /* Validation ---------------------------------------------------------- */

    photoLimit() {
      return this.config.countTiers ? this.units : this.config.maxPhotos || 1;
    }

    photosNeeded() {
      return this.config.countTiers ? this.units : 1;
    }

    validate() {
      if (!this.validateFields()) return false;

      const quoteOptions = this.choiceInputs.filter((input) => input.hasAttribute('data-charm-quote-option'));
      if (this.config.quoteRequired && quoteOptions.length && !quoteOptions.some((input) => input.checked)) {
        this.showError(this.strings.needQuote);
        return false;
      }

      if (!this.config.requirePhotos) return true;

      const needed = this.photosNeeded();
      if (this.photos.length >= needed) return true;

      // "Add the photo" reads better than "add 1 more photo" when only one was
      // ever asked for, which is every card doll.
      if (needed === 1) {
        this.showError(this.strings.needPhoto);
      } else {
        this.showError(this.fill(this.strings.needPhotos, needed - this.photos.length));
      }
      return false;
    }

    // A line that gets printed on a card cannot be guessed later and cannot be
    // asked for after the parcel ships, so the shopper is stopped at the first
    // empty one and sent straight to it.
    validateFields() {
      const empty = this.fieldInputs.find(
        (input) => input.hasAttribute('data-charm-required') && !input.value.trim() && !input.closest('[hidden]')
      );

      if (!empty) {
        this.fieldInputs.forEach((input) => input.removeAttribute('aria-invalid'));
        return true;
      }

      empty.setAttribute('aria-invalid', 'true');
      this.showError(this.fill(this.strings.needField, empty.dataset.charmLabel || ''));
      empty.focus();
      empty.scrollIntoView({ block: 'center' });
      return false;
    }

    /* Photos -------------------------------------------------------------- */

    addFiles(incoming) {
      const allowed = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
      // iOS often reports HEIC with an empty type, so the extension decides.
      const isHeicName = (name) => /\.hei[cf]$/i.test(name || '');
      const limit = this.photoLimit();
      let error = '';

      incoming.forEach((file) => {
        if (this.photos.length >= limit) {
          error = this.fill(this.strings.toomany, limit);
          return;
        }
        if (allowed.indexOf(file.type) === -1 && !isHeicName(file.name)) {
          error = this.strings.wrongType;
          return;
        }
        if (file.size > this.config.maxPhotoBytes) {
          error = this.strings.tooLarge;
          return;
        }
        this.photos.push(file);
      });

      this.showError(error);
      this.syncSlots();
    }

    removePhoto(index) {
      this.photos.splice(index, 1);
      this.showError('');
      this.syncSlots();
    }

    // Mirrors `photos` onto the real inputs Shopify posts, one per piece, and
    // hides the slots a smaller tier no longer needs.
    syncSlots() {
      const limit = this.photoLimit();

      if (this.photos.length > limit) this.photos.length = limit;

      this.slots.forEach((slot) => {
        slot.hidden = Number(slot.dataset.charmSlot) > limit;
      });

      // Colour rows and name fields follow the piece count the same way.
      const units = this.config.countTiers ? this.units : 1;
      this.unitBlocks.forEach((block) => {
        block.hidden = Number(block.dataset.charmUnit) > units;
      });

      if (this.canMirrorFiles()) {
        this.fileInputs.forEach((input) => {
          const index = Number(input.dataset.charmFile) - 1;
          const file = this.photos[index];
          const transfer = new DataTransfer();
          if (file && index < limit) transfer.items.add(file);
          input.files = transfer.files;
        });
      }

      if (this.frames) this.renderFrames();
    }

    // Copying a File onto a real input needs DataTransfer, which Safari only
    // learned in 14.1. Where it is missing the frames still preview the
    // choice and the plain inputs below carry the upload.
    canMirrorFiles() {
      if (this.mirrors === undefined) this.mirrors = typeof DataTransfer === 'function';
      return this.mirrors;
    }

    // One frame per photograph wanted: the filled ones show what was chosen,
    // the empty ones are the invitation to add the rest.
    renderFrames() {
      if (!this.frames) return;

      this.frames.querySelectorAll('img').forEach((img) => URL.revokeObjectURL(img.src));
      this.frames.textContent = '';

      const limit = this.photoLimit();

      for (let index = 0; index < limit; index += 1) {
        const file = this.photos[index];
        this.frames.appendChild(file ? this.filledFrame(file, index) : this.emptyFrame(index));
      }

      this.updatePhotoCount(limit);
    }

    filledFrame(file, index) {
      const frame = document.createElement('div');
      frame.className = 'charm__frame charm__frame--filled';

      const img = document.createElement('img');
      img.className = 'charm__frame-img';
      img.src = URL.createObjectURL(file);
      img.alt = file.name;
      frame.appendChild(img);

      frame.appendChild(this.frameIndex(index));

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'charm__frame-remove';
      remove.textContent = '×';
      remove.setAttribute('aria-label', this.fill(this.strings.removeHtml, index + 1));
      remove.addEventListener('click', () => this.removePhoto(index));
      frame.appendChild(remove);

      return frame;
    }

    emptyFrame(index) {
      const frame = document.createElement('div');
      frame.className = 'charm__frame charm__frame--empty';

      const add = document.createElement('button');
      add.type = 'button';
      add.className = 'charm__frame-add';
      add.setAttribute('aria-label', this.fill(this.strings.addPhotoHtml, index + 1));
      add.addEventListener('click', () => this.picker && this.picker.click());

      const plus = document.createElement('span');
      plus.className = 'charm__frame-plus';
      plus.setAttribute('aria-hidden', 'true');
      add.appendChild(plus);

      // Only the first empty frame carries the words. Repeating "add photo"
      // down a row of five is noise, and the cross already says it.
      if (index === this.photos.length) {
        const hint = document.createElement('span');
        hint.className = 'charm__frame-hint';
        hint.textContent = this.strings.addPhoto || '';
        add.appendChild(hint);
      }

      frame.appendChild(add);
      frame.appendChild(this.frameIndex(index));
      return frame;
    }

    frameIndex(index) {
      const badge = document.createElement('span');
      badge.className = 'charm__frame-index';
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = String(index + 1);
      return badge;
    }

    updatePhotoCount(limit) {
      if (!this.photoCount) return;
      this.photoCount.textContent = String(this.strings.photoCountHtml || '')
        .replace('__a__', this.photos.length)
        .replace('__n__', limit);
    }

    /* Add to cart ---------------------------------------------------------- */

    async onSubmit(event) {
      event.preventDefault();

      if (!this.validate()) return;

      const variantId = this.idInput && this.idInput.value;
      if (!variantId) return;

      this.setBusy(true);
      this.showError('');

      try {
        const body = new FormData();
        body.append('id', variantId);
        body.append('quantity', '1');

        // Only what the shopper actually typed. An empty property is a blank
        // row on the packing slip that reads like something went missing.
        this.fieldInputs.forEach((input) => {
          const value = input.value.trim();
          if (value && !input.closest('[hidden]')) body.append(input.name, value);
        });

        // Colours and quotes are radios: only the checked one in each visible
        // group reaches the order.
        this.choiceInputs.forEach((input) => {
          if (input.checked && input.value && !input.closest('[hidden]')) body.append(input.name, input.value);
        });

        const notes = this.form.querySelector('[name="properties[Notes]"]');
        if (notes && notes.value.trim()) body.append('properties[Notes]', notes.value.trim());

        this.fileInputs.forEach((input) => {
          const file = input.files && input.files[0];
          if (file) body.append(input.name, file);
        });

        // An add-on is its own cart line at its own price, so the order has to
        // say which piece it belongs to. The title carries that for a human
        // reading the order; the group id keeps it unambiguous when the same
        // product is personalized twice in one basket.
        const group = this.group();
        body.append('properties[_group]', group);

        await this.post('/cart/add.js', body);

        const extras = this.extraInputs
          .filter((input) => input.checked)
          .map((input) => ({
            id: Number(input.value),
            quantity: 1,
            properties: { 'Added to': this.config.productTitle, _group: group },
          }));

        if (extras.length) {
          await this.post('/cart/add.js', JSON.stringify({ items: extras }), {
            'Content-Type': 'application/json',
          });
        }

        // The cart panel opens over the page with the new lines; without one,
        // the cart page does the same job.
        if (window.MimoraCart) {
          await window.MimoraCart.added();
          this.setBusy(false);
        } else {
          window.location.href = this.root.dataset.cartUrl || '/cart';
        }
      } catch (error) {
        // Nothing is lost on a failed add: the photos stay in their frames, so
        // the shopper only has to tap the button again.
        const reason = error.message || this.strings.failed;
        this.showError(reason + ' ' + (this.strings.retryHint || ''));
        this.setBusy(false);
      }
    }

    async post(url, body, headers) {
      const response = await fetch(url, {
        method: 'POST',
        headers: Object.assign({ Accept: 'application/json' }, headers || {}),
        body: body,
      });

      const payload = await response.json().catch(() => null);

      if (!response.ok) {
        const reason = payload && (payload.description || payload.message);
        throw new Error(reason || this.strings.failed);
      }

      return payload;
    }

    setBusy(busy) {
      if (!this.submitButton) return;
      this.submitButton.disabled = busy;
      if (!this.submitText) return;
      this.submitText.textContent = busy
        ? this.submitButton.dataset.labelBusy
        : this.submitButton.dataset.labelDefault;
    }

    /* Helpers -------------------------------------------------------------- */

    showError(message) {
      if (!this.errorNode) return;
      this.errorNode.textContent = message || '';
      this.errorNode.hidden = !message;
    }

    fill(template, value) {
      return String(template || '').replace('__n__', value);
    }

    // Short, readable, and unique enough for one basket.
    group() {
      return Math.random().toString(36).slice(2, 8).toUpperCase();
    }

    money(cents) {
      const format = this.root.dataset.moneyFormat;
      // Same guard the product form uses: assemble the money placeholder
      // pattern at runtime so this file holds no literal Liquid output tag.
      const open = '\\{' + '\\{';
      const close = '\\}' + '\\}';
      const placeholder = new RegExp(open + '\\s*(\\w+)\\s*' + close);
      const match = format ? format.match(placeholder) : null;
      if (!match) return (cents / 100).toFixed(2);
      return format.replace(placeholder, () => this.amount(cents, match[1]));
    }

    // Separator and precision rules for each of Shopify's amount placeholders,
    // so a switched variant reads exactly like the price Liquid rendered.
    amount(cents, placeholder) {
      let precision = 2;
      let thousands = ',';
      let decimal = '.';

      if (placeholder.indexOf('no_decimals') !== -1) precision = 0;

      if (placeholder.indexOf('comma_separator') !== -1) {
        thousands = '.';
        decimal = ',';
      } else if (placeholder.indexOf('apostrophe_separator') !== -1) {
        thousands = "'";
      } else if (placeholder.indexOf('period_and_space_separator') !== -1) {
        thousands = ' ';
      } else if (placeholder.indexOf('space_separator') !== -1) {
        thousands = ' ';
        decimal = ',';
      }

      const parts = (cents / 100).toFixed(precision).split('.');
      const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
  }

  document.querySelectorAll('[data-charm]').forEach((root) => new Personalizer(root));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-bar"] && !Shopify.designMode) return;
  try {
    class StickyBar {
    constructor(root) {
      this.root = root;
      this.productRoot = root.closest('[data-product-root]') || document.querySelector('[data-product-root]');
      if (!this.productRoot) return;

      this.form = this.productRoot.querySelector('[data-product-form]');
      this.control = this.productRoot.querySelector('[data-charm-submit], [data-add-to-cart]');
      if (!this.form || !this.control) return;

      this.summary = root.querySelector('[data-sticky-summary]');
      this.extras = root.querySelector('[data-sticky-extras]');
      this.total = root.querySelector('[data-sticky-total]');
      this.button = root.querySelector('[data-sticky-submit]');
      this.buttonText = root.querySelector('[data-sticky-submit-text]');
      this.thumb = root.querySelector('[data-sticky-thumb]');

      this.button.addEventListener('click', () => this.submit());

      this.productRoot.addEventListener('product:variant', (event) => this.onVariant(event.detail && event.detail.variant));
      this.productRoot.addEventListener('product:total', (event) => this.onTotal(event.detail || {}));

      this.mirrorControl();
      this.watch();
      this.seedTotal();
    }

    // The bar is only wanted while the form's own button is off screen. The
    // button's row is what is watched, so the bar goes away as soon as any
    // part of the real one comes into view and comes back once it has gone.
    watch() {
      const anchor = this.control.closest('.charm__bar, [data-product-buttons]') || this.control;
      const apply = (inView) => {
        this.root.hidden = inView;
        this.root.setAttribute('aria-hidden', inView ? 'true' : 'false');
      };
      const check = () => {
        const rect = anchor.getBoundingClientRect();
        apply(rect.bottom > 0 && rect.top < window.innerHeight);
      };

      // Settled once from geometry so the first paint is right, then kept
      // right by the observer; a browser without one falls back to scrolling.
      check();
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          (entries) => entries.forEach((entry) => apply(entry.isIntersecting)),
          { threshold: 0 }
        ).observe(anchor);
      } else {
        window.addEventListener('scroll', check, { passive: true });
        window.addEventListener('resize', check);
      }
    }

    // The real button says whether the piece is available and whether an add
    // is in flight; the bar's button repeats it rather than deciding twice.
    mirrorControl() {
      const sync = () => {
        this.button.disabled = this.control.disabled;
        if (this.buttonText) this.buttonText.textContent = this.control.textContent.trim();
      };
      sync();
      const observer = new MutationObserver(sync);
      observer.observe(this.control, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
    }

    seedTotal() {
      const node = this.productRoot.querySelector('[data-charm-total], [data-cart-total]');
      if (node && this.total) this.total.innerHTML = node.innerHTML;
    }

    onVariant(variant) {
      if (!variant) return;
      if (this.summary) {
        this.summary.textContent = variant.title === 'Default Title' ? '' : variant.title;
      }
      if (this.thumb && variant.featured_image && variant.featured_image.src) {
        this.thumb.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
      }
    }

    onTotal(detail) {
      if (this.total && typeof detail.html === 'string') this.total.innerHTML = detail.html;
      if (this.extras) {
        const count = Number(detail.extras) || 0;
        this.extras.hidden = count === 0;
        this.extras.textContent = count ? this.root.dataset.stringExtras.replace('__count__', count) : '';
      }
    }

    submit() {
      if (this.control.disabled) return;
      // requestSubmit runs the form's own submit handler; click() on the
      // real button does the same in browsers without it.
      if (this.form.requestSubmit) this.form.requestSubmit(this.control);
      else this.control.click();

      // A missing photo or line is reported next to the form, so the form is
      // brought back into view when that happens.
      window.setTimeout(() => {
        const error = this.productRoot.querySelector('[data-charm-error]:not([hidden]), [data-cart-error]:not([hidden])');
        if (error) error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 80);
    }
  }

  document.querySelectorAll('[data-sticky-bar]').forEach((root) => new StickyBar(root));
  } catch(e) { console.error(e); }
})();

})();
